import get from 'lodash/get';
import triggerTracking from '@blueprint/tracking';
import { ListingResponse } from '../Listings/Listings.types';
import { isProperty } from '../helpers';
import { PropertyOrPromoItem } from '../helpers/featuredProperties';

type ProductTrackingObject = {
    variant: string;
    position: number;
    id: string;
    list: 'Featured listings';
};

const getVariant = (featuredType: ListingResponse['featuredType']): string => {
    const featuredTypeToVariant = {
        featured: 'Featured',
        weekly_featured: 'Weekly Featured'
    };

    const defaultVariant = featuredTypeToVariant.featured;

    return get(featuredTypeToVariant, featuredType ?? '', defaultVariant);
};

const getProductImpression = (
    item: PropertyOrPromoItem,
    position: number
): ProductTrackingObject =>
    isProperty(item)
        ? {
              id: item.listingId,
              list: 'Featured listings',
              position: position,
              variant: getVariant(item.featuredType)
          }
        : {
              id: 'Unfilled',
              list: 'Featured listings',
              position: position,
              variant: item
          };

export const trackFeaturedPropertyImpressions = (
    displayedItems: PropertyOrPromoItem[]
): void => {
    const productImpressions = displayedItems.map((item, index) =>
        getProductImpression(item, index + 1)
    );

    triggerTracking({
        event: 'GAEventEcommerce',
        ecommerce: {
            impressions: productImpressions
        }
    });
};

export const getOnClickTracking = (
    item: PropertyOrPromoItem,
    index: number
): (() => void) => () => {
    const { id, list, position, variant } = getProductImpression(
        item,
        index + 1
    );

    triggerTracking({
        event: 'GAEventEcommerce',
        ecommerce: {
            click: {
                actionField: {
                    list
                },
                products: [
                    {
                        id,
                        position,
                        variant
                    }
                ]
            }
        }
    });
};
